// extracted by mini-css-extract-plugin
module.exports = {"aboutCause":"AboutCause_aboutCause__XPuLO"};